<div class="custom-panel-description seatcard">
  <span
    class="pointer"
    (click)="onSelectedFlightOffer()"
    *ngIf="showBookingButton"
    >
    <span  *ngIf="facadeCheckout.flightPrice$ | async as flightPrice; else showPrice">
      {{ (flightOffer.actual_amount - flightPrice) >= 0 ? '+' : '-' }}
      {{ (flightOffer.actual_amount - flightPrice) | abs | currencyConverter123 | async }}
    </span>
    <ng-template #showPrice>
      +{{ flightOffer.total_amount | currencyConverter123 | async }}
    </ng-template>
  </span>
  <div class="flight-opt" *ngIf="checked && !isSummary">
    <label class="cst-chkbx" for="{{ flightOffer.Id }}">
      <input
        type="checkbox"
        id="{{ flightOffer.Id }}"
        name="{{ flightOffer.Id }}main"
        checked="true"
        [disabled]="true"
      />
      <span class="checkmark"></span>
    </label>
  </div>
  <tic-flight-option
    [flightLeg]="flightOffer.slices[0]"
    [outbound]="true"
    [parseDuration]="parseDuration"
    [parseLocation]="parseLocation"
  ></tic-flight-option>
  <tic-flight-option
    [flightLeg]="flightOffer.slices[1]"
    [inbound]="true"
    [parseDuration]="parseDuration"
    [parseLocation]="parseLocation"
  ></tic-flight-option>

  <tic-button
    className="btn-book-flight"
    buttonText="flightsPage.result.bookFlight"
    (btnClick)="onSelectedFlightOffer()"
    *ngIf="showBookingButton"
  ></tic-button>
</div>
<div *ngFor="let flightSlice of flightOffer.slices">
  <tic-flight-slice-summary
    [flightSlice]="flightSlice"
    [parseDuration]="parseDuration"
  ></tic-flight-slice-summary>
</div>
